import styled from 'styled-components'

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 24px 24px 24px;
  max-width: 1440px;
`
